const VARIABLE_TYPE_TO_INPUT = {
  Date: 'date',
  Time: 'time',
  Number: 'number',
  Email: 'email',
  Url: 'url',
}

export const getInputType = (variableType) =>
  VARIABLE_TYPE_TO_INPUT[variableType] || 'text'

export const normalizeVariable = (variable) => {
  if (typeof variable === 'string') {
    return { name: variable, description: null, isRequired: false, type: null }
  }
  return {
    name: variable.name,
    description: variable.description || null,
    isRequired: variable.isRequired || false,
    type: variable.type || null,
  }
}

// The AI auto-fill writes whatever the server returns straight into templateData, so a value here
// is not guaranteed to be a string — coerce before trimming.
const isBlank = (value) => !String(value ?? '').trim()

export const findMissingRequiredVariables = (variables, templateData) =>
  variables
    .map(normalizeVariable)
    .filter(({ name, isRequired }) => isRequired && isBlank(templateData?.[name]))
    .map(({ name }) => name)

export const formatMissingVariablesError = (names) =>
  `Please fill in the required ${names.length === 1 ? 'variable' : 'variables'}: ${names.join(', ')}`

export const formatVariableTypeHint = (type) =>
  type && type !== 'Text' ? ` [${type}]` : ''

export const formatVariableForPrompt = (variable) => {
  const { name, description, type } = normalizeVariable(variable)
  const desc = description ? ` (${description})` : ''
  const typeHint = formatVariableTypeHint(type)
  return `{{${name}}}${desc}${typeHint}`
}
